import React, { Component } from 'react';
import Constants from '../../Config/Config';

class Plaque extends Component {
	render() {
		const {
			plaqueTotal
		} = this.props;
		return (
			<tr>
				<th>Plaque</th>
				<td>&nbsp;</td>
				<td>{Constants.Currency + plaqueTotal}</td>
			</tr>
		);
	}
}

export default Plaque;